import React from 'react';

/**
 * Bouton WhatsApp flottant en bas à droite.
 * Renvoie vers wa.me au format international.
 */
const WhatsAppButton = () => {
  // 07 61 20 33 70 → +33 7 61 20 33 70 → 33761203370
  const phone = '33761203370';
  const message = encodeURIComponent('Bonjour, je souhaite avoir des renseignements sur vos machines laser.');
  const href = `https://wa.me/${phone}?text=${message}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Nous contacter sur WhatsApp"
      data-testid="whatsapp-float-btn"
      className="fixed z-50 bottom-6 right-6 group"
      style={{ WebkitTapHighlightColor: 'transparent' }}
    >
      <span className="absolute inset-0 rounded-full bg-green-500 opacity-70 animate-ping"></span>
      <span
        className="relative flex items-center justify-center w-14 h-14 rounded-full shadow-2xl transition-transform group-hover:scale-110"
        style={{ backgroundColor: '#25D366' }}
      >
        {/* Icône WhatsApp */}
        <svg viewBox="0 0 32 32" className="w-8 h-8 text-white" fill="currentColor" aria-hidden="true">
          <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39-.038 0-.075-.011-.113-.031-.291-.115-.783-.354-1.283-.598-1.014-.494-1.898-1.183-2.593-2.087-.115-.15-.293-.353-.293-.556 0-.203.203-.316.281-.395.181-.181.478-.478.541-.616.037-.076.037-.153.037-.229 0-.076-.037-.153-.075-.229-.076-.153-.685-1.652-.94-2.246-.191-.44-.409-.44-.6-.44-.153 0-.331-.019-.509-.019-.153 0-.401.043-.611.271-.209.229-.801.762-.801 1.868 0 1.106.826 2.187.945 2.34.115.153 1.633 2.493 3.988 3.489 2.353.997 2.353.664 2.777.626.428-.038 1.388-.554 1.583-1.089.196-.535.196-.994.135-1.089-.061-.096-.213-.153-.436-.271zm-2.966-9.203c-4.518 0-8.196 3.678-8.196 8.196 0 1.601.464 3.153 1.341 4.492l-1.398 4.087 4.186-1.376c1.284.706 2.746 1.079 4.229 1.079 4.518 0 8.196-3.678 8.196-8.196s-3.678-8.196-8.196-8.196zm0 15.02c-1.309 0-2.594-.352-3.72-1.014l-.267-.158-2.767.907.912-2.716-.174-.281c-.727-1.157-1.113-2.495-1.113-3.867 0-4.021 3.273-7.294 7.294-7.294s7.294 3.273 7.294 7.294-3.273 7.294-7.294 7.294z"/>
        </svg>
      </span>
      <span className="absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap bg-white text-gray-800 text-sm font-semibold py-2 px-3 rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Discuter sur WhatsApp
      </span>
    </a>
  );
};

export default WhatsAppButton;
